import {
  StatusFirst,
  StatusFourth,
  StatusSecond,
  StatusThird,
  WaringIcon,
} from '@/_assets/icon-components';
import { ISingleOrder } from '@/_service/types/orders';
import { getTrackingStatus } from '@/_utils/getStatus';
import { StepsItem, StepsList, StepsRoot } from '@/components/ui/steps';
import { Box, Container } from '@chakra-ui/react';
import React from 'react';

const Mobile = ({ order }: { order?: ISingleOrder }) => {
  if (!order) {
    return null;
  }

  const status = getTrackingStatus(order?.status_id);

  const stepMapping: Record<string, number> = {
    new: 0,
    future: 0,
    cancelled: 0,
    accepted: 1,
    getting_ready: 1,
    ready: 2,
    'courier-picked': 2,
    finished: 4,
    delivered: 4,
  };

  const activeStep = stepMapping[status] || 0;

  const steps = [
    {
      icon: (color: string) => <StatusFirst color={color} />,
      completedIcon: <StatusFirst color='white' />,
    },
    {
      icon: (color: string) => <StatusSecond color={color} />,
      completedIcon: <StatusSecond color='white' />,
    },
    ...(order.delivery_type !== 'self-pickup' &&
    order.order_type?.type !== 'hall'
      ? [
          {
            icon: (color: string) => <StatusThird color={color} />,
            completedIcon: <StatusThird color='white' />,
          },
        ]
      : []),
    {
      icon: (color: string) => <StatusFourth color={color} />,
      completedIcon: <StatusFourth color='white' />,
    },
  ];

  const renderSteps = (colorPalette: string, warning = false) => (
    <Container maxW={'300px'}>
      <StepsRoot
        mt={6}
        step={warning ? 5 : activeStep}
        colorPalette={colorPalette}
        count={steps.length}
        gap={0}
      >
        <StepsList gap={0} alignItems='center'>
          {steps.map((step, index) => {
            const isActive = !warning && index === activeStep;

            const iconColor = isActive
              ? 'var(--primary-default)'
              : 'var(--text-default)';
            return (
              <React.Fragment key={index}>
                <StepsItem
                  w={'48px'}
                  h={'48px'}
                  index={index}
                  bg={colorPalette}
                  borderColor={'#F2F4F7'}
                  icon={warning ? <WaringIcon /> : step.icon(iconColor)}
                  completedIcon={warning ? <WaringIcon /> : step.completedIcon}
                  showSeparator={true}
                />
                {index < steps.length - 1 && (
                  <Box w='17px' h='4px' borderRadius='999px' bg={'#D9D9D9'} />
                )}
              </React.Fragment>
            );
          })}
        </StepsList>
      </StepsRoot>
    </Container>
  );
  if (status === 'cancelled') {
    return renderSteps('red', true);
  }
  if (order?.payment_type === 'online' && !order?.paid) {
    return renderSteps('var(--primary-default)');
  }

  return renderSteps('var(--primary-default)');
};

export default Mobile;
